export function typeOfObject(object: any): string | null {
    const objectType = Object.prototype.toString.call(object);
    const objectTypeMatch = /^\[object ([a-zA-Z]*)\]$/.exec(objectType);
    return objectTypeMatch?.[1] || null;
  }